import { Just, Nothing, ofNullable } from './maybe';
import type { Maybe } from './maybe';

export type Empty = Nothing;
export const Empty = Nothing;

export type Loaded<T> = Just<T>;
export const Loaded = Just;

export type Loading = ['loading'];
const _loading: Loading = ['loading'];

export const Loading = (): Loading => _loading;

export type Creating<T> = ['creating', T];
export const Creating = <T>(value: T): Creating<T> => ['creating', value];

export type Updating<T> = ['updating', T, T];
export const Updating = <T>(next: T, previous: T): Updating<T> => [
  'updating',
  next,
  previous,
];
export const commit = <T>([, next]: Updating<T>): Loaded<T> => Loaded(next);
export const revert = <T>([, , previous]: Updating<T>): Loaded<T> =>
  Loaded(previous);

export type Deleting<T> = ['deleting', T];
export const Deleting = <T>(value: T): Deleting<T> => ['deleting', value];

export type Refreshing<T> = ['refreshing', T];
export const Refreshing = <T>(previous: T): Refreshing<T> => [
  'refreshing',
  previous,
];

export const valueOf = <T>([, value]:
  | Loaded<T>
  | Creating<T>
  | Updating<T>
  | Refreshing<T>
  | Deleting<T>): T => value;
export const maybeValueOf = <T>([, value]:
  | Empty
  | Loading
  | Loaded<T>
  | Creating<T>
  | Updating<T>
  | Refreshing<T>
  | Deleting<T>): Maybe<T> => ofNullable(value ?? null);
